import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getAssetsData = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: { pageNo: number; pageSize: number };
			app: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/utilities/getAllAssets',
				queryParams: {
					appName
				},
				body: {
					page: { pageNo: pageDetails.pageNo, pageSize: pageDetails.pageSize },
					filters: filterDetails,
					sortInfoArray: sortDetails
				}
			});
			const data = _get(result, ['data', 'data']);
			const listData = formatListData(data.assets);
			return { rowCount: data.count, data: listData };
		},
		[]
	);

	const requestCreateAsset = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/utilities/createNewAsset',
			body: data,
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		getAssetsData,
		requestCreateAsset
	};
};

export default useService;
